<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <!-- Dynamic Parent -->
      <router-link v-if="fromNotifications"
        :to="{ name: 'ViewPendingNotifications', query: { entityType: route.query.entityType, statusInd: route.query.statusInd } }"
        class="mb-0 main-identifier fw-semibold text-decoration-none">
        Notifications
      </router-link>

      <router-link v-else :to="{ name: 'ViewManualAppraisals' }"
        class="mb-0 main-identifier fw-semibold text-decoration-none">
        Manual Appraisals
      </router-link>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">View Imported Appraisal</p>
    </div>

    <div class="d-flex justify-content-center mb-5">

      <div class="form-outer">
        <form @submit.prevent="step === totalSteps ? handleSubmit() : handleNext()">
          <div class="crud-form position-relative">

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <!-- <h4>View Imported Appraisal (Step {{ step }} of {{ totalSteps }})</h4> -->
                <h1 class="mb-0">Imported Appraisal</h1>
              </div>

              <div class="form-body mt-2 mb-3">
                <div v-if="step === 1">

                  <!-- <h2 class="field-head">A. General Information</h2> -->
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Appraisal Completion Date</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input " :value="formatDate(form.issueDate)"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Originating MDA</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input " v-model="form.originatingMda"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Approval Authority</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input " v-model="form.approvalAuthority"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Budget Year</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input " v-model="form.budgetYear"
                        placeholder="" readonly>
                    </div>
                  </div>
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Initiator</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input " v-model="form.initiatorName"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Group Head</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input " v-model="form.sectoralHeadName"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Director of Budget</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input " v-model="form.dobName"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Permanent Secretary</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input " v-model="form.psName" placeholder=""
                        readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Commissioner</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input " v-model="form.commissionerName"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Quarter</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input " v-model="form.quarter"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Nature of Expenditure</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input " :value="natureOfExpenditureLabel"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Amount Approved</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input "
                        :value="'₦' + formatCurrency(form.amountApproved || 0)" placeholder="" readonly>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <h2 class="field-head">B. Budget</h2> -->

              <div class="row mb-3 budget-item-wrapper step-2 justify-content-center">
                <div class="row content-wrapper section-border h-100 w-100">
                  <div class="col d-flex">
                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                      <label class="form-label fw-bold fixed-label">Organizational Code</label>
                      <input type="text" class="form-control view-only-input text-center" v-model="form.orgCode"
                        readonly>
                    </div>
                  </div>
                  <!-- <div class="col d-flex">
                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                      <label class="form-label fw-bold fixed-label">Budget Year</label>
                      <input type="text" class="form-control view-only-input text-center" v-model="form.budgetYear"
                        readonly>
                    </div>
                  </div> -->
                  <div class="col d-flex">
                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                      <label class="form-label fw-bold fixed-label">Approved Budget Amount</label>
                      <input type="text" class="form-control view-only-input text-center"
                        :value="'₦' + formatCurrency(form.approvedBudgetAmount || 0)" readonly />
                    </div>
                  </div>

                  <div class="col d-flex">
                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                      <label class="form-label fw-bold fixed-label">Approved Released To Date</label>
                      <input type="text" class="form-control view-only-input text-center"
                        :value="'₦' + formatCurrency(form.amtReleasedToDate || 0)" readonly />
                    </div>
                  </div>
                  <div class="col d-flex">
                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                      <label class="form-label fw-bold fixed-label">Balance</label>
                      <!-- display the formatted string -->
                      <input type="text" class="form-control view-only-input text-center"
                        :value="'₦' + formatCurrency(form.balance || 0)" readonly />
                    </div>
                  </div>
                  <!-- <div class="col d-flex">
                                  <div class="d-flex flex-column justify-content-center h-100 w-100">
                                    <label class="form-label fw-bold fixed-label ">Performance (%)</label>
                                    <input type="text" class="form-control view-only-input text-center" v-model="form.performance" readonly>
                                  </div>
                                </div> -->
                </div>
                <div class="table-responsive mt-4">
                  <table class="table table-bordered appraisal-view text-center align-middle">
                    <thead class="table-light">
                      <tr>
                        <th>Eco Code</th>
                        <th>Title</th>
                        <th>Approved Budget {{ form.budgetYear }}</th>
                        <th>Approval Release To Date</th>
                        <th>Balance</th>
                        <!-- <th>Performance (%)</th> -->
                        <th>Amount Approved</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in economicItems" :key="index"
                        :class="index % 2 === 0 ? 'row-even' : 'row-odd'">
                        <td>
                          {{ item.ecoCode }}
                        </td>
                        <td>
                          {{ item.title }}
                        </td>
                        <td>
                          ₦{{ formatCurrency(item.amountBudgeted || 0) }}
                        </td>
                        <td>
                          ₦{{ formatCurrency(item.amountReleased || 0) }}
                        </td>
                        <td>
                          ₦{{ formatCurrency(item.balance || 0) }}
                        </td>
                        <!-- <td>
                                        {{ item.performance }}%
                                      </td> -->
                        <td>
                          ₦{{ formatCurrency(item.amountApproved || 0) }}
                        </td>

                        <!-- <td>
                                        <input
                                          type="number"
                                          min="0"
                                          class="form-control form-control-sm"
                                          v-model.number="item.amountRequired"
                                          @input="validateBudgetStep"
                                        />
                                        {{ item.amountRequired }}
                                      </td> -->
                      </tr>
                    </tbody>
                  </table>

                  <!-- <div class="mt-3 text-end">
                                  <button type="button" class="btn btn-outline-primary btn-sm" @click="addEconomicItem">
                                    <span class="iconify" data-icon="mdi:plus"></span> Add More
                                  </button>
                                </div> -->
                </div>
              </div>

              <!-- <h2 class="field-head">C. Evaluation Of Expenditure Approval Limits</h2> -->
              <div class="row mb-3">
                <!-- <div class="row mb-3 budget-item-wrapper justify-content-center" style="margin-left: 3px; margin-right: 3px; margin-top:0;">
                                  <div class="col-md-2 d-flex no-border">
                                    <div class="d-flex flex-row justify-content-center h-100 w-100">
                                    <label for="year" class="form-label fw-bold fixed-label">Year:</label>
                                    <input type="text" class="form-control view-only-input text-center" v-model="form.year" placeholder="" readonly>
                                  </div>
                                  </div>

                                  <div class="col-md-5 d-flex no-border">
                                    <div class="d-flex flex-row justify-content-center h-100 w-100">
                                    <label for="year" class="form-label fw-bold fixed-label">Date:</label>
                                      <input type="text" class="form-control view-only-input text-center" v-model="form.exp_date" placeholder="" readonly>
                                    </div>
                                  </div>

                                  <div class="col-md-2 d-flex no-border">
                                    <div class="d-flex flex-row justify-content-center h-100 w-100">
                                      <label for="year" class="form-label fw-bold fixed-label">Quarter:</label>
                                      <input type="text" class="form-control view-only-input text-center" v-model="form.exp_quarter" placeholder="" readonly>
                                    </div>
                                  </div>
                                </div> -->


                <!-- <div class="row mb-3 budget-item-wrapper justify-content-center step-3" style="margin-left: 3px; margin-right: 3px; margin-top: 15px;">


                                  <div class="col d-flex">
                                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                                    <label for="year" class="form-label fw-bold fixed-label">Quarterly Authorization Limit Number</label>
                                      <input type="text" class="form-control view-only-input text-center" v-model="form.noOfAuthIssuedInQtr" placeholder="" readonly>
                                    </div>
                                  </div>

                                  <div class="col d-flex">
                                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                                    <label for="year" class="form-label fw-bold fixed-label">Number Already Approved In Quarter</label>
                                      <input type="text" class="form-control view-only-input text-center" v-model="form.noOfAppLimitPerQtr" placeholder="" readonly>
                                    </div>
                                  </div>

                                  <div class="col d-flex">
                                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                                    <label for="year" class="form-label fw-bold fixed-label">Quarterly Authorized Limit Balance</label>
                                      <input type="text" class="form-control view-only-input text-center" v-model="form.noOfAuthLeftInQtr" placeholder="" readonly>
                                    </div>
                                  </div>



                                  <div class="col d-flex">
                                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                                    <label for="year" class="form-label fw-bold fixed-label">Quarterly Authorized Amount</label>
                                    <input type="hidden" v-model="form.qtrAuthLimitAmt">
                                    <input type="text" class="form-control view-only-input text-center" :value="Number(form.qtrAuthLimitAmt || 0).toLocaleString()" placeholder="" readonly>
                                    </div>
                                  </div>

                                  <div class="col d-flex">
                                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                                    <label for="year" class="form-label fw-bold fixed-label">Approved Capital Amount</label>
                                    <input type="hidden" v-model="form.evalApprovedCapitalAmount">
                                    <input type="text" class="form-control view-only-input text-center" :value="Number(form.evalApprovedCapitalAmount || 0).toLocaleString()" placeholder="" readonly>
                                    </div>
                                  </div>

                                  <div class="col d-flex">
                                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                                    <label for="year" class="form-label fw-bold fixed-label">Approved Recurrent Amount</label>
                                    <input type="hidden" v-model="form.evalApprovedRecurrentAmount">
                                    <input type="text" class="form-control view-only-input text-center" :value="Number(form.evalApprovedRecurrentAmount || 0).toLocaleString()" placeholder="" readonly>
                                  </div>
                                  </div>

                                  <div class="col d-flex">
                                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                                      <label for="year" class="form-label fw-bold fixed-label">Approval Balance</label>
                                      <input type="hidden" v-model="form.evalApprovalBalance">
                                      <input type="text" class="form-control view-only-input text-center" :value="Number(form.evalApprovalBalance || 0).toLocaleString()" placeholder="" readonly>
                                    </div>
                                  </div>
                                </div> -->

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Evaluation Remark</label></div>
                  <div class="col-md-7 input-right">
                    <div class="col-md-12 input-right">
                      <textarea type="text" class="form-control form-view-only-input" v-model="form.evalRemarks"
                        placeholder="" readonly>
                      </textarea>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Total Amount Approved</label></div>
                  <div class="col-md-7">
                    <input type="text" class="form-control form-view-only-input"
                      :value="'₦' + formatCurrency(totalRecommended)" placeholder="" readonly>

                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group"
                  v-if="form.sectoralHeadRemarks">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Sectoral Remark</label></div>
                  <div class="col-md-7 input-right">
                    <div class="col-md-12 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.sectoralHeadRemarks"
                        placeholder="" readonly>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group" v-if="form.dobRemarks">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Director of Budget Remark</label></div>
                  <div class="col-md-7 input-right">
                    <div class="col-md-12 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.dobRemarks"
                        placeholder="" readonly>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group" v-if="form.permSecRemarks">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Permanent Secretary Remark</label></div>
                  <div class="col-md-7 input-right">
                    <div class="col-md-12 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.permSecRemarks"
                        placeholder="" readonly>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group"
                  v-if="form.commissionerRemarks">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Commissioner Remark</label></div>
                  <div class="col-md-7 input-right">
                    <div class="col-md-12 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.commissionerRemarks"
                        placeholder="" readonly>
                    </div>
                  </div>
                </div>


                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Appraisal Status</label></div>
                  <div class="col-md-7 input-right">
                    <div class="col-md-12 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="appraisalStatus"
                        placeholder="" readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4 mb-2">
                <div class="d-flex justify-content-end gap-3 warrant-download-btn-wrapper mb-3">

                  <div>
                    <router-link :to="{ name: 'UpdateManualAppraisal', params: { id: id } }"
                      class="btn btn-outline-primary edit-btn-app text-decoration-none">
                      Edit
                    </router-link>
                  </div>

                  <div v-if="userStore.profile?.role.groupHead || userStore.profile?.role.groupMember">
                    <button v-if="appraisalStatus === 'Completed'" type="button"
                      class="btn btn-outline-primary  download-btn-app" @click="downloadWarrant"
                      :disabled="loadingDownload" aria-live="polite"
                      :aria-label="loadingDownload ? 'Downloading...' : 'Download Warrant'">
                      <span v-if="loadingDownload" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>
                      {{ loadingDownload ? 'Downloading...' : 'Download Warrant' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { useRoute } from 'vue-router';
import { useUserStore } from '@/stores/user';
// import { useRouter } from 'vue-router';

// const router = useRouter();

const fromNotifications = computed(() => route.query.from === 'ViewPendingNotifications' && route.query.entityType && route.query.statusInd)
const root_api_url = process.env.VUE_APP_API_ROOT_URL
const totalSteps = 3
const step = ref(1)
// const loading = ref(false)

const route = useRoute()
const id = route.params.id
const loadingAccept = ref(false)
const submitted = ref(false)
const hasSavedAllRemarks = ref(false)
const loadingDownload = ref(false)
const isApproved = ref(false)
const isRejected = ref(false)
const userStore = useUserStore()

// Reactive form data
const form = reactive({
  id: '',
  originatingMda: '',
  approvalAuthority: '',
  natureOfExpenditure: '',
  amountApproved: '',
  purposeOfRequest: '',
  approvedBudgetAmount: '',
  amtReleasedToDate: '',
  balance: '',
  performance: '',
  quarter: '',
  budgetYear: '',
  appraisalInitiatedDate: '',
  noOfAppLimitPerQtr: '',
  noOfAuthIssuedInQtr: '',
  noOfAuthLeftInQtr: '',
  qtrAuthLimitAmt: '',
  approvedRecurrentAmount: '',
  approvedCapitalAmount: '',
  approvalBalance: '',
  evalRemarks: '',
  amtRecommended: '',
  sectoralHeadRemarks: '',
  dobRemarks: '',
  commissionerRemarks: '',
  orgCode: '',
  permSecRemarks: '',
  appraisalInitiatorId: '',
  sectoralHeadId: '',
  sectoralHeadRemarkDate: '',
  dobId: '',
  dobRemarkDate: '',
  permSecId: '',
  permSecRemarksDate: '',
  commissionerId: '',
  commRemarkDate: '',
  appraisalCompletionDate: '',
  initiatorRemarks: '',
  issueDate: '',
  importedAppraisalInd: '',

  initiatorName: '',
  sectoralHeadName: '',
  dobName: '',
  psName: '',
  commissionerName: '',
})

function formatCurrency(val) {
  if (val === '' || val === null || val === undefined) return '';
  const num = Number(val);
  if (isNaN(num)) return '';
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const formatDate = (dateString) => {
  if (!dateString) return '—'
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return '—'
  return date.toLocaleDateString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

const economicItems = ref([])

const fetchAppraisal = async () => {
  const token = Cookies.get('auth_token')
  try {
    const { data } = await axios.get(`${root_api_url}/appraisal/appraisal/import/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })



    // console.log(data);
    form.originatingMda = data.originatingMda;
    form.approvalAuthority = data.approvalAuthority;
    form.natureOfExpenditure = data.natureOfExpenditure

    form.amountApproved = data.amountApproved;
    form.purposeOfRequest = data.purposeOfRequest;
    form.approvedBudgetAmount = data.approvedBudgetAmount;
    form.amtReleasedToDate = data.amtReleasedToDate;
    form.balance = data.balance;
    // form.performance = data.performance;
    form.quarter = data.quarter;
    form.budgetYear = data.budgetYear;
    // form.appraisalInitiatedDate = data.appraisalInitiatedDate;
    // form.noOfAppLimitPerQtr = data.noOfAppLimitPerQtr;
    // form.noOfAuthIssuedInQtr = data.noOfAuthIssuedInQtr;
    // form.noOfAuthLeftInQtr = data.noOfAuthLeftInQtr;
    // form.qtrAuthLimitAmt = data.qtrAuthLimitAmt;
    // form.approvedRecurrentAmount = data.approvedRecurrentAmount;
    // form.approvedCapitalAmount = data.approvedCapitalAmount;
    // form.approvalBalance = data.approvalBalance;
    form.evalRemarks = data.evalRemarks;
    form.orgCode = data.orgCode;
    form.sectoralHeadRemarks = data.sectoralHeadRemarks;
    // form.amtRecommended          = data.amtRecommended;
    form.dobRemarks = data.dobRemarks;
    form.permSecRemarks = data.permSecRemarks;
    form.issueDate = data.issueDate,
      form.initiatorName = data.initiatorName,
      form.sectoralHeadName = data.sectoralHeadName,
      form.dobName = data.dobName,
      form.psName = data.psName,
      form.commissionerName = data.commissionerName,
      // form.appraisalInitiatorId = data.appraisalInitiatorId;
      // form.sectoralHeadId = data.sectoralHeadId;
      // form.sectoralHeadRemarkDate = data.sectoralHeadRemarkDate;
      // form.dobId = data.dobId;
      // form.dobRemarkDate = data.dobRemarkDate;
      // form.permSecId = data.permSecId;
      // form.permSecRemarksDate = data.permSecRemarksDate;
      form.commissionerRemarks = data.commissionerRemarks;
    // form.commissionerId = data.commissionerId;
    // form.commRemarkDate = data.commRemarkDate;
    // form.issueDate = data.issueDate;
    // form.evalApprovedRecurrentAmount = data.evalApprovedRecurrentAmount;
    // form.evalApprovedCapitalAmount = data.evalApprovedCapitalAmount;
    // form.evalApprovalBalance = data.evalApprovalBalance;
    isApproved.value = Boolean(data.importedAppraisalInd);
    // isRejected.value = Boolean(data.appraisalRejectedInd);


    hasSavedAllRemarks.value = Boolean(data.importedAppraisalInd);
    form.importedAppraisalInd = data.importedAppraisalInd,

      // hasSavedAllRemarks.value = !!data.commissionerRemarks

      economicItems.value = (data.appraisalEconomicItems || []).map(dto => ({
        id: dto.id,
        //ecoCode: dto.economicLineItemDto.economicCode,
        ecoCode: dto.ecoCode,
        title: dto.title,
        mdaLineItemBudgetId: dto.mdaLineItemBudgetId,
        amountBudgeted: dto.amountBudgeted,
        amountReleased: dto.amountReleased,
        balance: dto.balance,
        amountRequired: dto.amountRequired,
        year: dto.year,
        quarter: dto.quarter,
        eliAmountRecommended: dto.amountRecommended || 0,
        amountApproved: dto.amountApproved,
        amountRecommended: dto.amountRecommended,
      }));

  } catch (err) {
    console.error('Error loading ECO items:', err)
    const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`
    Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>${err?.response?.data?.errorMessage || err?.response?.data?.error || err?.response?.data?.message || 'Failed to load appraisal details. Please try again.'}</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
  }
}

const totalRecommended = computed(() => {
  return form.amountApproved;
});

const natureOfExpenditureLabel = computed(() => {
  return form.natureOfExpenditure == 2
    ? 'Recurrent'
    : form.natureOfExpenditure == 3
      ? 'Capital'
      : form.natureOfExpenditure == 4
        ? 'Hybrid'
        : ''
})

const appraisalStatus = computed(() => {
  // compute the status
  let status

  if (isApproved.value) {
    status = 'Completed'
  } else if (isRejected.value) {
    status = 'Rejected'
  } else {
    status = 'Pending'
  }
  // log the raw values and the result
  // console.log(
  //   '🧪 appraisalStatus computed:',
  //   {
  //     dobRemarks: form.dobRemarks,
  //     sectoralHeadRemarks: form.sectoralHeadRemarks,
  //     commissionerRemarks: form.commissionerRemarks,
  //     permSecRemarks: form.permSecRemarks,
  //     status
  //   }
  // );

  return status;
});





const handleSubmit = async () => {
  const token = Cookies.get('auth_token');

  loadingAccept.value = true;
  submitted.value = true;

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  const appraisalData = {
    ...form,
    commissionerRemarks: form.commissionerRemarks,
    natureOfExpenditure: form.natureOfExpenditure,
    id: id,
    appraisalEconomicItems: economicItems.value.map(item => ({
      id: item.id,
      appraisalId: id,
      mdaLineItemBudgetId: item.mdaLineItemBudgetId,
      ecoCode: item.ecoCode,
      title: item.title,
      amountBudgeted: item.amountBudgeted,
      amountReleased: item.amountReleased,
      balance: item.balance,
      amountRequired: item.amountRequired,
      amountRecommended: item.eliAmountRecommended,
      year: item.year,
      quarter: item.quarter
    }))
  }

  try {
    await axios.put(`${root_api_url}/appraisal/appraisal/${id}`, appraisalData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    Swal.fire({
      html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Appraisal Updated Successfully</p> `,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    }).then(() => {
      hasSavedAllRemarks.value = true
      window.location.reload()
    });

  } catch (err) {
    Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>Failed to initiate appraisal</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
  } finally {
    loadingAccept.value = false;
    submitted.value = false;
  }
}


onMounted(() => {
  fetchAppraisal(),
    document.title = "View Imported Appraisal"
})



const handleNext = async () => {
  // if (step.value === 2 && !hasSavedAllRemarks.value) {
  //   const missing = economicItems.value.some(item => !item.eliAmountRecommended)

  //   if (missing) {
  //     // Show error if any recommended‑amount is blank/zero
  //     await Swal.fire({
  //       icon: 'warning',
  //       title: 'Incomplete',
  //       text: 'Please enter an Amount Recommended for every line item before proceeding.',
  //     })
  //     return
  //   }

  //   form.amtRecommended = totalRecommended.value;
  // }

  if (step.value < totalSteps) step.value++
}

// const handleBack = () => {
//   if (step.value > 1) step.value--
// }


const downloadWarrant = async () => {
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`
  loadingDownload.value = true
  const token = Cookies.get('auth_token')

  try {
    const response = await axios.get(
      `${root_api_url}/appraisal/warrant/pdf/1/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob'
      }
    )

    let downloadName = 'warrant.pdf' // default filename

    const disposition = response.headers['content-disposition']
    console.log('Content-Disposition header:', response.headers)

    if (disposition && disposition.includes('filename=')) {
      downloadName = disposition
        .split('filename=')[1]
        .replace(/"/g, '')
    }

    // trigger file download
    const blob = new Blob([response.data], { type: response.data.type })
    const fileName = `${downloadName}`
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // IE11
      window.navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  } catch (error) {
    if (error.response) {
      // responseType is 'blob', so error bodies come back as a Blob too.
      // Read it back as text/JSON to extract the real error message.
      let message = 'Unexpected error occured, kindly contact administrator'
      try {
        const data = error.response.data
        if (data instanceof Blob) {
          const text = await data.text()
          const parsed = JSON.parse(text)
          message = parsed.errorMessage || parsed.error || message
        } else {
          message = data?.errorMessage || data?.error || message
        }
      } catch (e) {
        // leave default message if the body isn't JSON
      }

      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${message}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    } else {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred. Kindly contact administrator</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }
  } finally {
    loadingDownload.value = false
  }
}


</script>

<style scoped>
.col-md-5 {
  width: 35% !important
}

.view-only-input {
  border: none !important;
  background-color: transparent;
  padding-left: 0;
  cursor: default;
  pointer-events: none;
  color: #212529;
  font-size: 1rem;
}

.dashboard-layout .budget-item-wrapper {
  margin-top: 20px;
  padding: 0 20px;
}

.dashboard-layout .budget-item-wrapper .col {
  border: 1px solid #212529;
}

/* .dashboard-layout .budget-item-wrapper.step-3 {
  margin-top: 3px !important;
  } */


.dashboard-layout .budget-item-wrapper.step-3 .fixed-label {
  display: flex;
  align-items: center;
  /* vertical center */
  justify-content: center;
  /* horizontal center */
  min-height: 80px;
  width: 100%;
  padding: 0 0.25rem;
  box-sizing: border-box;
  text-align: center;
  /* ensure text is centered if it wraps */
  border-bottom: 1px solid #000;
}

.dashboard-layout .budget-item-wrapper.step-3 .col {
  padding: 0;
}

.dashboard-layout .budget-item-wrapper.step-3 label {
  font-size: 14px;
  padding: .375rem 0 !important;
  margin-bottom: 0px !important;
}

.dashboard-layout .budget-item-wrapper .col-md-5 {
  border: 1px solid #212529;
}

.dashboard-layout .budget-item-wrapper .col-md-5.no-border {
  border: none;

}

.dashboard-layout .budget-item-wrapper .col-md-5.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .budget-item-wrapper .col-md-2.no-border {
  border: none;

}

.dashboard-layout .budget-item-wrapper .col-md-2.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .fixed-label {
  display: flex;
  align-items: center;
  /* vertical center */
  justify-content: center;
  /* horizontal center */
  min-height: 4rem;
  width: 100%;
  padding: 0 0.25rem;
  box-sizing: border-box;
  text-align: center;
  /* ensure text is centered if it wraps */
}

.table-bordered.appraisal-view th {
  font-size: 14px;
}

.table-bordered.appraisal-view thead {
  background: none;
}

.table-bordered.appraisal-view thead th {
  border: 1px solid black;
  background: none;
  /* Optional, in case inherited styles override */
}

.table-bordered.appraisal-view tbody {
  background: none;
}

.table-bordered.appraisal-view tbody td {
  border: 1px solid black;
  background: none;
  /* Optional, in case inherited styles override */
}

.warrant-download-btn-wrapper .btn {
  margin-right: 10px;
  border-radius: 0px;
  padding: 10px;
  width: auto;
}

.warrant-download-btn-wrapper .edit-btn-app {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1.5;
}
</style>
